import React from 'react';

export default () => <div id="dropdown__host" />;
